import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/cn';

function useOverlayTypeStyles() {
  const { t } = useTranslation();
  return {
    trade_route: { color: '#c0392b', label: t('atlas.tradeRoutes'), icon: '—' },
    city: { color: '#2c3e50', label: t('atlas.cities'), icon: '●' },
    battle: { color: '#e74c3c', label: t('atlas.battles'), icon: '✕' },
    event: { color: '#8e44ad', label: t('atlas.events'), icon: '◆' },
    migration: { color: '#e67e22', label: t('atlas.migrations'), icon: '→' },
  };
}

export default function OverlayPanel({ overlays, activeOverlays, onToggle, selectedYear }) {
  const { t } = useTranslation();
  const OVERLAY_TYPE_STYLES = useOverlayTypeStyles();
  if (!overlays || overlays.length === 0) return null;

  // Only show overlays that overlap the current year
  const relevantOverlays = overlays.filter((o) => {
    if (!o.year_min && !o.year_max) return true;
    const min = o.year_min || -5000;
    const max = o.year_max || 2100;
    return selectedYear >= min && selectedYear <= max;
  });

  if (relevantOverlays.length === 0) return null;

  return (
    <div
      className={cn(
        'absolute bottom-20 left-4 z-10',
        'bg-white/95 dark:bg-gray-800/95 backdrop-blur-sm',
        'border border-gray-200 dark:border-gray-700',
        'rounded-lg shadow-lg',
        'w-52'
      )}
    >
      <div className="px-3 py-2 border-b border-gray-100 dark:border-gray-700">
        <span className="text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wide">
          {t('atlas.overlays')}
        </span>
      </div>
      <div className="px-3 py-2 space-y-1">
        {relevantOverlays.map((overlay) => {
          const style = OVERLAY_TYPE_STYLES[overlay.overlay_type] || OVERLAY_TYPE_STYLES.event;
          const isActive = activeOverlays.includes(overlay.slug);

          return (
            <label
              key={overlay.slug}
              className="flex items-center gap-2 cursor-pointer py-0.5 group"
            >
              <input
                type="checkbox"
                checked={isActive}
                onChange={() => onToggle(overlay.slug)}
                className="rounded border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-gray-400 h-3.5 w-3.5"
              />
              <span
                className="text-sm flex-shrink-0"
                style={{ color: style.color }}
              >
                {style.icon}
              </span>
              <span className={cn(
                'text-xs truncate',
                isActive
                  ? 'text-gray-800 dark:text-gray-200'
                  : 'text-gray-500 dark:text-gray-400'
              )}>
                {overlay.name}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
